<template>
    <Transition>
    <div
      v-if="upsellModal"
      id="modal_1"
      class="fixed top-0 z-50 flex items-center w-full h-screen overflow-hidden bg-gray-800 bg-opacity-50"
    >
      <div
        class="flex items-center justify-center w-full px-4 py-20 mx-auto md:px-20 2xl:mx-auto"
      >
        <div
          class="relative flex flex-col items-center justify-center w-full max-w-screen-lg px-4 py-10 bg-white border-t-8 border-yellow-600 shadow-lg md:w-auto lg:px-24"
        >
        <p class="w-10/12 pb-6 m-0 mx-auto text-xl font-bold text-center uppercase opacity-75 font-ww-medium sm:text-2xl md:w-4/5 lg:text-4xl"
            >
              <strong>
                LIMITED TIME OFFER
                <span class="time-left" v-show="!countdownFormatted.includes('undefined')"> {{ countdownFormatted }} </span> LEFT
              </strong>
            </p>
  
          <div class="w-full modal-header">
            <div
              class="flex justify-between w-full mb-2 space-x-3 text-sm font-semibold"
            >
              <div class="item">Add to Cart</div>
              <div class="text-center item sm:text-left">Upgrade Options</div>
              <div class="text-right item">Secure Checkout</div>
            </div>
            <div class="w-full mb-6 progress progress-striped active">
              <div
                class="progress-bar progress-bar-success"
                :class="{
                  'w-3/4': crosssell.show,
                  'w-1/2': !crosssell.show,
                }"
              >
                <span>&nbsp;</span>
              </div>
            </div>
          </div>
  
          <!-- modal body 1 start -->
          <div v-show="upsell" class="w-full modal-body">
            <div
              class="w-full px-2 py-2 text-center bg-gray-100 border border-gray-300"
              role="banner"
            >
              <p class="m-0 text-md lg:text-lg xl:text-xl">
                New Customer One-Time Special Offer
              </p>
              <p
                class="m-0 mx-auto text-xl font-bold text-center uppercase opacity-75 md-max:font-bold font-ww-medium sm:text-2xl md:w-4/5 lg:text-3xl xl:text-4xl"
                
              >
                SAVE AN EXTRA 68% WHEN YOU DOUBLE YOUR ORDER
              </p>
            </div>
            <div class="flex items-center px-2 mt-6 space-x-4 md:space-x-8">
              <div class="w-8/12 h-auto item md:w-2/3">
                <h1
                  role="main"
                  class="text-2xl font-semibold leading-7 text-left text-gray-800 lg:text-3xl lg:leading-9"
                >
                  Lucky You!
                </h1>
                <div data-body-copy="">
                  <p class="mt-2 font-normal text-justify text-md sm:text-xl">
                    You’ve found our
                    <span class="italic">New Customer Special</span> - our biggest
                    savings anywhere in our store.
                  </p>
                  <p class="mt-2 font-normal text-justify text-md sm:text-xl">
                    You only get this deal one-time. Lock in the huge extra 68%
                    savings today!
                  </p>
                  <p class="mt-2 font-normal text-md sm:text-xl">
                    <s class="mr-2 text-lifeboost-red">${{ selectedProduct.compareAtPrice }}</s>
                    <strong class="text-2xl">${{ selectedProduct.price }}</strong>
                  </p>
                </div>
              </div>
              <div class="w-4/12 h-auto item md:w-1/3">
                <nuxt-img
                  class="mx-auto"
                  loading="lazy"
                  :src="selectedProduct.image"
                />
              </div>
            </div>
            <div class="w-full px-5 space-y-3 text-center md:space-y-4">
              <button
                @click="setChoice('upsell', true, selectedProduct)"
                class="btn--special font-ww-medium relative mx-auto w-11/12 cursor-pointer whitespace-nowrap pb-3.5 pt-2.5 text-sm sm:text-lg md:w-5/6 md:text-xl xl:text-2xl"
              >
                Yes! Upgrade My savings
              </button>
            </div>
            <button
              @click="setChoice('upsell', false)"
              class="block mx-auto text-sm leading-none text-center text-gray-800 underline focus:outline-none"
            >
              No thanks, I’ll pass on this one-time offer
            </button>
            <button
            @click="cart.checkout(addPromoCode)"
              class="absolute text-gray-300 cursor-pointer right-4 top-4 focus:outline-none focus:ring-2 focus:ring-gray-800 focus:ring-offset-2 lg:right-6 lg:top-6"
              aria-label="close"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 6L6 18"
                  stroke="currentColor"
                  stroke-width="1.66667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M6 6L18 18"
                  stroke="currentColor"
                  stroke-width="1.66667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </button>
          </div>
          <!-- modal body 1 end -->
  
          <!-- modal body 2 start -->
          <div v-show="crosssell" class="w-full modal-body">
            <div
              class="w-full px-2 py-2 text-center bg-gray-100 border border-gray-300"
              role="banner"
            >
              <p
                class="px-2 m-0 mx-auto text-lg font-bold text-center uppercase opacity-75 font-ww-medium sm:text-2xl md:text-3xl lg:text-3xl"
              >
                Save $30 When You Add Our
                <span class="italic">Signature Roast Bundle</span> to Your Order
              </p>
            </div>
            <div
              class="flex items-center px-2 mx-auto mt-4 space-x-4 md:space-x-8 md:gap-10"
            >
              <div class="w-8/12 h-auto item md:w-2/3">
                <p class="mt-2 font-normal text-justify text-md sm:text-xl">
                  Try all three of our most popular roasts at a huge discount.
                  Enjoy our delicious organic Medium Roast, Dark Roast, and
                  Espresso Roast. All are shade grown, high-elevation grown,
                  tested for over 400 toxins, low acid, and d-e-l-i-c-i-o-u-s!
                </p>
                <p class="mt-2 font-normal text-md sm:text-xl">
                  <s>$104.85</s> $74.85
                  <strong class="italic">(Save $30!)</strong>
                </p>
              </div>
              <div class="w-4/12 h-auto item md:w-1/3">
                <nuxt-img
                  class="w-full mx-auto"
                  loading="lazy"
                  src="assets/images/image-coffee.png"
                />
              </div>
            </div>
            <div class="w-full px-5 space-y-3 text-center md:space-y-4">
              <button
                @click="setChoice('crosssell', true, products[2])"
                class="btn--special font-ww-medium relative mx-auto w-11/12 cursor-pointer whitespace-nowrap pb-3.5 pt-2.5 text-lg tracking-wide sm:text-lg md:w-5/6 md:text-xl xl:text-2xl font-bold"
              >
                Yes! Upgrade My Order
              </button>
            </div>
            <button
              @click="setChoice('crosssell', false)"
              class="block mx-auto text-sm leading-none text-center text-gray-800 underline focus:outline-none"
  
            >
              No thanks, I’ll pass on this opportunity to try these three roasts
              at a big discount…
            </button>
            <button
            @click="cart.checkout(addPromoCode)"
              class="absolute text-gray-800 cursor-pointer right-6 top-6 focus:outline-none focus:ring-2 focus:ring-gray-800 focus:ring-offset-2"
              aria-label="close"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 6L6 18"
                  stroke="currentColor"
                  stroke-width="1.66667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M6 6L18 18"
                  stroke="currentColor"
                  stroke-width="1.66667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </button>
          </div>
          <!-- modal body 2 end -->
        </div>
      </div>
    </div>
    </Transition>
  </template>
  
  <style scoped>
  @import "@/modal.css";
  
  .v-enter-active,
  .v-leave-active {
    transition: opacity 0.5s ease;
  }
  
  .v-enter-from,
  .v-leave-to {
    opacity: 0;
  }
  </style>
  
  <script setup>
  

  const cart = useCart();
  const props = defineProps(["selectedProduct", "products"]);
  const upsellModal = useState('upsellModal')
  const upsell = ref(true)
  const crosssell = ref(false)
  const addPromoCode = ref('?discount=%20')
  
  
  const countdown = ref({
    minutes: null,
    seconds: null,
  });
  
  onMounted(() => {
    if (localStorage.getItem("countdownTime") == null) {
      const randomMinutes = 2 + Math.floor(Math.random() * 2);
      const randomSeconds = Math.floor(Math.random() * 60);
      const future = new Date(new Date().getTime() + randomMinutes * 60000 + randomSeconds * 1000);
      
      localStorage.setItem("countdownTime", future);
      startTimer(future);
    } else {
      const savedTime = new Date(localStorage.getItem("countdownTime"));
      startTimer(savedTime);
    }
  });
  
  function startTimer(future) {
    setInterval(() => {
      updateTime(future);
    }, 1000);
  }
  
  function updateTime(future) {
    if (future.getTime() < new Date().getTime()) {
      const newFuture = new Date(new Date().getTime() + 2 * 60 * 1000);
      localStorage.setItem("countdownTime", newFuture);
      future = newFuture;
    }
  
    const diff = future - new Date();
    const mins = Math.floor(diff / (1000 * 60));
    const secs = Math.floor(diff / 1000) - mins * 60;
  
    countdown.value = {
      minutes: mins,
      seconds: secs,
    };
  }
  
  const padZero = (value) => String(value).padStart(2, "0");
  
  // Defined a computed property "countdownFormatted" to format the countdown value
  const countdownFormatted = computed(() => {
    return `${padZero(countdown.value.minutes)}:${padZero(countdown.value.seconds)}`;
  });
  
  watch(
    () => upsellModal.value,
    (newVal) => {
      if (newVal) showModal();
    },
  );
  
  function addBonuses(items){
    const mergedItems = Object.values(
        items.reduce((acc, item) => {
          if (!acc[item.id]) {
            acc[item.id] = { ...item };
          } else {
            acc[item.id].qty += item.qty; // Summing up the qty
          }
          return acc;
        }, {})
    );

    if(mergedItems[0].qty >= 3){
        cart.add({id:'42120155168828', qty: 1, price: 0.00 , title: 'The Ultimate Toxin-Free Living Guide - Digital eBook'})
        cart.add({id:'39411358498876', qty: 1, price: 0.00 , title: '100 Espresso Recipes From Around The World - Digital Recipe eBook'},)
        addPromoCode.value = '?discount=CRM-BONUS,CRM-FS,CRM-3DISCOUNT'
    }
    if(mergedItems[0].qty >= 6){
        cart.add({id:'42133501018172', qty: 1, price: 0.00 , title: 'Copper Lifeboost Coffee Scoops'})
        cart.add({id:'42239840190524', qty: 1, price: 0.00 , title: 'Bonus Coffee Perks'})
        addPromoCode.value = '?discount=CRM-BONUS,CRM-FS,CRM-6DISCOUNT'
    }
    if(mergedItems[0].qty >= 12){
        addPromoCode.value = '?discount=CRM-BONUS,CRM-FS,CRM-12DISCOUNT'
    }
  }
  
  function setChoice(offerType, upgrade, item) {
    switch(offerType) {
      case "upsell":
          if(upgrade) {
            cart.add(item);
          }
          upsell.value = false;
          crosssell.value = true;
        break;
      case "crosssell":
          upgrade && cart.add(item);
        
          addBonuses(cart.items().value);
          cart.checkout(addPromoCode.value);
        break;
    }
  }
  
   
  
  function updateCountdownElement() {
    const minutes = Math.floor(countdown.value / 60);
    const seconds = countdown.value % 60;
    countdown.value = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  }
  
  function showModal() {
    upsell.value = true;
    crosssell.value = false;
    document.documentElement.style.overflow = 'hidden'
    updateCountdownElement();
  }
  
  
  defineBuilderComponent({
      friendlyName: 'UpSell',
      ignored: true
  })
  </script>
  